/** Extract projectGroupId from Wixar package name (com.WideWebVR.P{id}_{name}) */
export function extractProjectGroupId(packageName: string): number | null {
  const match = packageName.match(/\.P(\d+)_/);
  return match ? parseInt(match[1], 10) : null;
}
